import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VetReservation} from "../vet-reservation.model";

export class VetReservationsDgSearchResults extends GenericDgSearchResults {
  public results: VetReservation[];

  constructor(total: number, results: VetReservation[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
